import { mutations } from './mutations'
import { actions } from './actions'

const data_base = () => {
  const mes_passado = new Date()
  mes_passado.setMonth(mes_passado.getMonth() - 1)
  return mes_passado.getFullYear()
}

export const receitas_despesas = {
  state: () => ({
    ano_base: data_base(),
    loading: false,
    receitas_proprias: [],
    detalhamento_despesas: [],
    grupo_despesas: [],
    funcao_subfuncao: [],
    adiantamentos: [],
    despesas_detalhadas: []
  }),
  getters: {
    isLoading: state => state.loading
  },
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/receitas_despesas/index.js